<template>
  <div v-if="archivos.id_documento " class="column scroll-vertical">
    <div class="card card-info border-0" style="background-color: #414c58;">
      <div class="card-header pt-0 pb-0" style="background-color: #42678d;">
        <a
          class="btn btn-link text-light"
          data-toggle="collapse"
          href="#collapseOne"
          role="button"
          aria-expanded="false"
          aria-controls="collapseOne"
        >
          Referencias de normatividad regional
        </a>
      </div>
      <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
        <div class="card-body">
          <div v-for="(nor,innor) in referentes.archivosdoc" :key="innor">
            <span>
              <p v-for="(nor2,indnor) in nor.ref_normatividad" :key="indnor" class="p-0 m-0 text-light">
                {{ nor2.regulations.reg_title }}
                <a v-for="fil in nor2.regulations.files" :key="fil.id" :href="'https://proyectos.regionhuanuco.gob.pe/regulations/file/'+nor2.regulations.id+'/'+fil.file_tomo+'/'+fil.file_nro_tipo" target="_blank"><span class="badge badge-danger pt-0 pb-0 pr-1 pl-1">
                  Tomo{{ fil.file_tomo+1 }}
                </span></a>
              </p>      
            </span>
          </div>
        </div>
      </div>
    </div>

    
    <span class="text-info">Los documentos adjuntos de <b>{{ archivos.id_documento }}</b> son los siguientes:</span>

    <!-- inicio de acordion -->
    <div id="accordion" class="panel-group" role="tablist" aria-multiselectable="true">
      <div v-for="(item, index) in referentes.archivosdoc" :key="index" class="panel panel-default p-0">
        <template v-if="item.docu_archivo.length>0">
          <div :id="'heading'+index" class="panel-heading p-0 bg-success text-white" role="tab">
            <h4 class="panel-title">
              <a
                data-toggle="collapse"
                data-parent="#accordion"
                :href="'#collapse'+index"
                :aria-controls="'collapse'+index"
                :class="{ collapsed: index !== 0 }"
              >
                <span class="text-white">
                  <span class="badge badge-success"><b>Reg.doc:</b> {{ item.iddocumento }} </span>
                  {{ item.tipo_documento.tdoc_descripcion }} N° {{ ('000000' + item.docu_numero_doc).slice(-6) }}-{{ item.docu_siglas_doc }} 
                </span>
              </a>
            </h4>
          </div>
          <div
            :id="'collapse'+index"
            class="panel-collapse collapse"
            :class="{ in: index === 0 }"
            role="tabpanel"
            :aria-labelledby="'heading'+index"
          >
            <div class="panel-body p-0 pr-1" style="background-color: black;">
              <table cellpadding="0" cellspacing="0" width="100%">
                <tr v-for="(item2, index2) in item.docu_archivo" :key="index2">
                  <td v-if="item2.file_mostrar===true">
                    <button
                      type="button"
                      class="btn btn-xs btn-link doc-link p-0"
                      :class="{ 'text-success': isSelectedForSign(item2.id) }"
                      @click="verdocumento({id:item2.id, id_documento:item2.id_documento, file_tipo: item2.file_tipo, file_name: item2.file_name, tipo:1})"
                    >
                      <span v-if="isSelectedForSign(item2.id)" class="glyphicon glyphicon-ok text-success"></span>
                      <span style="color:blue;font-size:70%" :class="(visorpdf==true)?'text-warning':''">{{ getFormatBytes(item2.file_size) }}</span>
                      <span
                        v-if="item2.file_principal != null"
                        :class="item2.file_principal? 'badge badge-danger': 'badge badge-warning'"
                        style="font-size: 70%;"
                      >
                        {{ item2.file_principal?'P':'A' }}
                      </span>
                      <span
                        :class="
                          item2.file_tipo.indexOf('image') === 0
                            ? 'glyphicon glyphicon-picture'
                            : 'glyphicon glyphicon-file'
                        "
                      ></span>
                      <span>{{ recortatexto(item2.file_name,30) }}</span>
                    </button>
                    <span class="text-info">{{ 'Fecha: '+item2.created_at.substr(0, 10) }}</span>
                  </td>
                  <td v-else>
                    <span class="badge badge-info">El trámite fue realizado de forma física</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </template>
        <template v-else>
          <div :id="'heading'+index" class="panel-heading pt-0 pb-0 bg-success text-white" role="tab">
            <h4 class="panel-title">
              <a
                data-toggle="collapse"
                data-parent="#accordion"
                :href="'#collapse'+index"
                :aria-controls="'collapse'+index"
                :class="{ collapsed: index !== 0 }"
              >
                <span class="text-white"><span class="badge badge-success"><b>Reg.doc:</b> {{ item.iddocumento }} </span><br /> {{ item.tipo_documento.tdoc_descripcion }} N° {{ ('000000' + item.docu_numero_doc).slice(-6) }}-{{ item.docu_siglas_doc }} </span>
              </a>
            </h4>
          </div>
          <div
            :id="'collapse'+index"
            class="panel-collapse collapse"
            :class="{ in: index === 0 }"
            role="tabpanel"
            :aria-labelledby="'heading'+index"
          >
            <div class="panel-body" style="background-color: black;">
              <span class="badge badge-info">El trámite fue realizado de forma física</span>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- fin de acordion -->


  </div>
</template>

<script>
import axios from '@/js/plugins/client'
import Vuex from 'vuex'
export default {
  name  : 'ResumenfoliosVisor',
  props : {
    archivos : {
      type    : Object,
      default : ()=>{}
    },
    referentes : {
      type    : Object,
      default : ()=>{ archivosdoc : null }
    },
    docFirmar : {
      type    : Array,
      default : () => []
    }
  },
  emits : ['show'],
  data() {
    return {
      visorpdf : false,
      
    };
  },
  computed : {
    ...Vuex.mapGetters([
      'getFormatBytes'
    ]),
    foliosFisico(){
      return this.referentes.archivosdoc!=null?this.referentes.archivosdoc.filter(d=>d.docu_archivo.filter(f=>f.file_mostrar==1).length==0).reduce((a,c)=>a+c.docu_folios,0):0
    },
    totalFolios(){
      return this.referentes.archivosdoc!=null?this.referentes.archivosdoc.reduce((a,c)=>a+c.docu_folios,0):0
    }
  },

  mounted() {
    // if(this.doiddocumento!=0)
    // {this.mostrarresultados(this.iddocumento)}
    
    
  },

  methods : {
    verdocumento(documento)
    {
      this.$emit('show', documento);
    },
    isSelectedForSign(fileId) {
      return this.docFirmar.includes(fileId)
    },
    recortatexto(cadena,d)
    {
      if (cadena.length <= d) {
        return cadena;
      }
      return cadena.substring(0, d) + '...';
    },
  },
};
</script>

<style scoped>
  .table tbody tr td,
  .table thead tr th {
    font-size: 10px;
    font-family: Tahoma;
    vertical-align: middle;
  }
  .column {
    position: fixed;
    bottom: 0;
    width: 31%;
    /* background-color: lightblue; */
    /* text-align: center; */
    }
  .badge{
    font-weight:100!important;
  }
  /* .scroll-vertical {
    max-height: 50vh;
    overflow-y: scroll; */
    /* border: 1px solid #000; */
    /* padding: 10px;
  } */
  .scroll-vertical {
  max-height: 50vh;
  overflow-y: auto;
  padding: 10px;
  scrollbar-width: thin; /* Ancho del scrollbar (solo para Firefox) */
}

/* Estilo del scrollbar (para navegadores basados en WebKit) */
.scroll-vertical::-webkit-scrollbar {
  width: 10px; /* Ancho del scrollbar */
}

/* Estilo del track del scrollbar (fondo) */
.scroll-vertical::-webkit-scrollbar-track {
  background: #f1f1f1; /* Color de fondo del track */
  border-radius: 10px; /* Bordes redondeados */
}

/* Estilo del pulgar del scrollbar (parte desplazable) */
.scroll-vertical::-webkit-scrollbar-thumb {
  background: #888; /* Color del pulgar */
  border-radius: 10px; /* Bordes redondeados */
}

/* Estilo del pulgar del scrollbar al pasar el ratón */
.scroll-vertical::-webkit-scrollbar-thumb:hover {
  background: #555; /* Color del pulgar al pasar el ratón */
}
span{
  font-size: 13px;
}
</style>
